import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Table from "../../Components/Script/Table";
import { createPaymentOrder, verifyPayment } from "../../Services/paymentService";
import apiClient from "../../Services/apiClient";
import $ from "jquery";

function AllServiceApplication() {

    const [applications, setApplications] = useState([]);
    const [loading, setLoading] = useState(true);
    const tableRef = useRef(null);

    useEffect(() => {
        fetchApplications();
    }, []);

    useEffect(() => {

        if (
            loading ||
            !applications.length ||
            !tableRef.current ||
            !window.$ ||
            !$.fn.DataTable
        ) return;

        const table = $(tableRef.current);

        if ($.fn.DataTable.isDataTable(table)) {
            table.DataTable().destroy();
        }

        setTimeout(() => {
            table.DataTable({
                scrollX: true
            });
        }, 0);

    }, [loading, applications]);



    const fetchApplications = async () => {

        try {

            setLoading(true);

            const user = JSON.parse(localStorage.getItem("user"));
            const userId = user?.id;

            const res = await apiClient.get(`ServiceApplication/user/${userId}`);

            const sortedData = res.data.sort(
                (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
            );

            setApplications(sortedData);

        } catch (err) {

            console.error(err);

        } finally {

            setLoading(false);

        }

    };



    const handlePayment = async (applicationId) => {

        try {

            const orderData = await createPaymentOrder(applicationId);

            const options = {

                key: orderData.key,
                amount: orderData.amount * 100,
                currency: "INR",
                order_id: orderData.orderId,
                name: "Service Application Payment",
                description: "Application Fee Payment",

                handler: async function (response) {

                    await verifyPayment({
                        applicationId: applicationId,
                        orderId: response.razorpay_order_id,
                        paymentId: response.razorpay_payment_id,
                        signature: response.razorpay_signature
                    });

                    alert("Payment Successful");

                    fetchApplications();
                },

                modal: {
                    ondismiss: function () {
                        alert("Payment cancelled");
                    }
                }

            };

            const rzp = new window.Razorpay(options);
            rzp.open();

        } catch {

            alert("Unable to initiate payment");

        }

    };



    return (

        <div>

            <Table />

            <div className="wrapper">

                <div className="content-page">

                    <div className="content">

                        <div className="container-fluid">

                            {/* Page Title */}

                            <div className="row">

                                <div className="col-12">

                                    <div className="page-title-box">

                                        <div className="page-title-right">

                                            <ol className="breadcrumb m-0">

                                                <li className="breadcrumb-item">
                                                    <Link to="/dashboard">Dashboard</Link>
                                                </li>

                                                <li className="breadcrumb-item active">
                                                    My Service Applications
                                                </li>

                                            </ol>

                                        </div>

                                        <h4 className="page-title">
                                            My Service Applications
                                        </h4>

                                    </div>

                                </div>

                            </div>


                            {/* Table */}

                            <div className="row">

                                <div className="col-12">

                                    <div className="card">

                                        <div className="card-body">

                                            <div className="table-responsive">

                                                <table
                                                    ref={tableRef}
                                                    className="table table-striped table-bordered nowrap w-100"
                                                >

                                                    <thead>

                                                        <tr>

                                                            <th>Lead Id</th>
                                                            <th>Service Name</th>
                                                            <th>Payment Amount</th>
                                                            <th>Payment Status</th>
                                                            <th>Application Status</th>
                                                            <th>Created Date</th>

                                                        </tr>

                                                    </thead>

                                                    <tbody>

                                                        {applications.length > 0 ? (
                                                            applications.map((app) => {

                                                                const paymentStatusText =
                                                                    app.paymentStatus === 0 ? "Pending" :
                                                                        app.paymentStatus === 1 ? "Paid" :
                                                                            "Failed";

                                                                const applicationStatusText =
                                                                    app.applicationStatus === 0 ? "Submitted" :
                                                                        app.applicationStatus === 1 ? "DocumentPending" :
                                                                            app.applicationStatus === 2 ? "InProgress" :
                                                                                app.applicationStatus === 3 ? "Approved" :
                                                                                    app.applicationStatus === 4 ? "Rejected" :
                                                                                        app.applicationStatus === 5 ? "Completed" :
                                                                                            "OnHold";

                                                                return (
                                                                    <tr key={app.id}>

                                                                        <td>{app.leadNumber}</td>
                                                                        <td>{app.service?.name}</td>

                                                                        <td>₹ {app.paymentAmount}</td>

                                                                        <td>

                                                                            {app.paymentStatus === 0 && app.service?.serviceGroupId !== 3 ? (

                                                                                <button
                                                                                    className="btn btn-sm btn-warning"
                                                                                    onClick={() => handlePayment(app.id)}
                                                                                >
                                                                                    Pay Now
                                                                                </button>

                                                                            ) : (

                                                                                <span
                                                                                    className={`badge ${app.paymentStatus === 1
                                                                                            ? "bg-success"
                                                                                            : app.paymentStatus === 2
                                                                                                ? "bg-danger"
                                                                                                : "bg-secondary"
                                                                                        }`}
                                                                                >
                                                                                    {app.service?.serviceGroupId === 3
                                                                                        ? "-"
                                                                                        : paymentStatusText}
                                                                                </span>

                                                                            )}

                                                                        </td>

                                                                        <td>

                                                                            <span className="badge bg-info">
                                                                                {applicationStatusText}
                                                                            </span>

                                                                        </td>

                                                                        <td>
                                                                            {new Date(app.createdAt).toLocaleString()}
                                                                        </td>

                                                                    </tr>

                                                                );

                                                            })

                                                        ) : (

                                                            <tr>
                                                                <td colSpan="6" className="text-center">
                                                                    No Data Found
                                                                </td>
                                                            </tr>

                                                        )}

                                                    </tbody>

                                                </table>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

}

export default AllServiceApplication;